const appConfig = {
    // apiPrefix: 'http://localhost:8000/apis/admin',
    // apiPrefix: 'http://localhost:4000/apis/admin/auth/',
   
    apiPrefix:process.env.REACT_APP_API_URL || 'https://api.blackdogdata.net/apis/admin/auth/',

    authenticatedEntryPath: '/app/dashboard',
    unAuthenticatedEntryPath: '/sign-in',
    tourPath: '/app/account/kyc-form',
    locale: 'en',
    enableMock: false,
}

export default appConfig
